import { render, staticRenderFns } from "./SearchingSolshare.vue?vue&type=template&id=153d2e54&scoped=true"
import script from "./SearchingSolshare.vue?vue&type=script&lang=js"
export * from "./SearchingSolshare.vue?vue&type=script&lang=js"
import style0 from "./SearchingSolshare.vue?vue&type=style&index=0&id=153d2e54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153d2e54",
  null
  
)

export default component.exports